import { Component, OnInit } from '@angular/core';
import { ValueService } from 'src/app/services/value.service';

@Component({
  selector: 'app-contact-page',
  templateUrl: './contact-page.component.html',
  styleUrls: ['./contact-page.component.css'],
})
export class ContactPageComponent implements OnInit {
  constructor(private getdata: ValueService) {}

  /**
   * Initializes the component by setting the visibility of a source observable to true.
   */
  ngOnInit(): void {
    // Set the visibility of a source observable to true
    this.getdata.isVisibleSource.next(true);
  }
}
